import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Particle from "../Particle";

// Import images
import awsImg from "../../Assets/aws-saa.png";
import microsoft from "../../Assets/microsoft-azure.png";
import nptel from "../../Assets/iit-nptel.png";
import udemy from "../../Assets/udemy.png";

const certifications = [
  {
    name: "AWS Certified Solutions Architect - Associate",
    image: awsImg,
    link: "https://www.credly.com/badges/b9855226-38a1-4acb-8a76-a9e5ed6ce7e6/public_url",
  },
  {
    name: "Perform Cloud Data Science with Microsoft Azure Machine Learning",
    image: microsoft,
    link: "https://www.credly.com/badges/ab77c4a9-3e83-4323-89b5-add1f52bcd07/linked_in_profile",
  },
{
    name: "Databricks Certified Data Engineer Associate - Preparation",
    image: udemy,
    link: "https://www.udemy.com/certificate/UC-3f001885-2ffd-46d6-b3c0-6a012c608bb9/",
  },
  {
    name: "Programming, Data Structures and Algorithms using Python",
    image: nptel,
    link: "https://archive.nptel.ac.in/noc/Ecertificate/?q=linkedin/noc17-cs10/NPTEL17CS1026580424AN.jpg",
  },

];

const Certificate = () => (
  <section>
    <Container fluid className="home-section" id="certifications">
      <Particle />
      <Container className="home-content" style={{ padding: "12rem 0" }}>
        {/* Heading matching Home tab */}
        <h1 className="heading text-center mb-5">
          My <strong className="main-name">Certifications</strong>
        </h1>

        {/* Certification cards */}
        <Row className="justify-content-center" xs={1} sm={2} md={3} lg={3} xl={4}>
          {certifications.map((cert, idx) => (
            <Col key={idx} className="mb-4 d-flex justify-content-center">
              <Card
                onClick={() => window.open(cert.link, "_blank")}
                style={{
                  width: "200px",
                  cursor: "pointer",
                  border: "none",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  borderRadius: "12px",
                  backgroundColor: "transparent", // let it inherit dark theme
                }}
                className="text-white"
              >
                <Card.Img
                  variant="top"
                  src={cert.image}
                  style={{ borderRadius: "12px", height: "auto" }}
                />
                <Card.Body>
                  <Card.Title
                    className="text-center"
                    style={{
                      fontSize: "1rem",
                      color: "white",
                      minHeight: "3.5em",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      lineHeight: 1.2,
                    }}
                  >
                    {cert.name}
                  </Card.Title>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </Container>
  </section>
);

export default Certificate;
